/**
 * @prettier
 */
import DescriptionKeyword from "../../components/keywords/Description"
import { createOnlyOAS31ComponentWrapper } from "../../../fn"

const DescriptionWrapper = createOnlyOAS31ComponentWrapper(DescriptionKeyword)

export default DescriptionWrapper
